import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrandingData } from '../models/branding.model';
import { environment } from '../../environments/environment';

export const BRANDING_LOGO_API_PATH = '/api/v1/branding/logo';
export const BRANDING_LOGO_TYPES: readonly string[] = ['image/png', 'image/jpeg', 'image/webp'];

@Injectable({ providedIn: 'root' })
export class BrandingApiService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/branding`;

  getBranding(): Observable<BrandingData> {
    return this.http.get<BrandingData>(this.apiUrl);
  }

  updateBranding(data: BrandingData): Observable<BrandingData> {
    return this.http.put<BrandingData>(this.apiUrl, data);
  }

  uploadLogo(file: File): Observable<BrandingData> {
    const body = new FormData();
    body.append('file', file);
    return this.http.post<BrandingData>(`${environment.apiBaseUrl}${BRANDING_LOGO_API_PATH}`, body);
  }

  /** `path` ist der Backend-Pfad aus `BrandingData.logoPath`; die API liegt in Prod auf einer anderen Origin. */
  getLogo(path: string): Observable<Blob> {
    return this.http.get(`${environment.apiBaseUrl}${path}`, { responseType: 'blob' });
  }
}
